import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vShow as _vShow, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-008e85e8"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_2 = {
  class: "content__container mg-b--15"
};
const _hoisted_3 = {
  class: "header"
};
const _hoisted_4 = ["onClick"];
import { useExcelImport } from '@/utils/useExcelImport';
import { useRoute, useRouter } from 'vue-router';
import TagType from '@/views/common/TagType/index.vue';
import { objToArr, transferTime, getItemByProp, treeIterator } from '@/utils/tools';
import Buttons from '@/components/Buttons/index.vue';
import { messageBox } from '@/utils/validate';
import UploadFile from '@/views/liveChannel/components/uploadFile.vue';
import { getLiveChannelListApi, getLanguageListApi, getSysDictListApi, sortShowNoApi, getsubBrandListApi, batchDeleteChannelsApi, getEnListApi, getCpspCategoriesApi, deleteChannelsApi, exportChannelListApi, getChannelDetailApi } from '@/api/live';
import { nextTick, onMounted, watch } from 'vue';
import { ProgramTypeObject } from '@/assets/config/dicts';
import dayjs from 'dayjs';
import { useCommon } from '@/store/useCommon';
import { ElMessage } from 'element-plus';
import { getCurrentTime } from '@/utils/timeFormat';
import { useI18n } from 'vue-i18n';
import { liveStore } from '@/store/liveStore';
import BatchOperation from '@/views/liveChannel/components/batchOperation.vue';
import { getUserByCidApi } from '@/api/authority';
import { useBrandsByUser } from '@/utils/cacheData';
import CheckChannel from '@/views/liveChannel/components/checkChannel.vue';
import AddChannel from './addChannel/index.vue';
import PhysicalChannel from '@/views/liveChannel/components/physicalChannel.vue';
import InfoDialog from '@/views/liveChannel/components/infoDialog.vue';
import XEUtils from 'xe-utils';
import { findLabel } from '@/utils/tools.ts';
import LookBack from '@/views/liveChannel/components/lookBack.vue';
import BatchButton from '@/views/liveChannel/components/batchButton.vue';
import TimeShift from '@/views/liveChannel/components/timeShift.vue';
import PaidSetting from './addChannel/components/paidSetting.vue';
import Encoding from './addChannel/components/encoding.vue'; // 表格列排序

export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props) {
    const {
      t
    } = useI18n();
    const route = useRoute();
    const router = useRouter();
    const isShowAside = ref(true);
    const loading = ref(true);
    const isVnoAccount = useCommon().userData.roles.some(item => /VNO/ig.test(item)) || useCommon().userData.roles.includes('CUSTOMER_SN'); //区分是否为vno运营商账号

    const tableContainer = ref(null);
    const tableWarpRef = ref(null);
    const selectedNodes = ref([]); //tree组件选中的节点

    const tableRef = ref();
    const infoDialog = reactive({
      visible: false
    });
    const lookBackObj = reactive({
      visible: false,
      selectedChannel: []
    }); //批量设置时移对象

    const timeShiftObj = reactive({
      visible: false,
      selectedChannel: []
    });
    const batchBtnDisabled = ref(true); // 批量操作按钮的禁用

    const paidSettingObj = reactive({
      visible: false,
      ids: []
    });
    const EndcodingObj = reactive({
      visible: false,
      ids: []
    }); //运营商id vno账号下有一个id，否则就是根据下拉框来选  注意：后续端口用到cpspId时，如果不是vno账号要重新从sessionStorage获取

    const cpspId = isVnoAccount ? useCommon().userData.cid[0] : Number(sessionStorage.getItem('currentCid'));
    const languageList = ref([]);
    const sysDictList = ref([{
      label: t('全部'),
      value: ''
    }]);
    const activeList = ref([{
      label: t('全部'),
      value: ''
    }, {
      label: t('未激活'),
      value: 1
    }]);
    const enList = ref([]);
    const selectedChannelIdList = ref([]);
    const selectedChannel = ref([]);
    const tagRef = ref();
    const sortParams = reactive({
      orderBy: undefined,
      orderType: undefined
    });
    const activeTag = ref(0); //激活的tag标签，默认0:全部

    const operatorList = ref([]); //操作用户列表

    const transferProtocolObj = ref([{
      value: '',
      label: t('全部')
    }]);
    const REVIEW_STATUS = {
      '0': '全部',
      '1': '未审核',
      '2': '未通过',
      '3': '终端审核',
      '4': '退回审核',
      '5': '已审核'
    };
    const ReviewStatus = {
      '0': t('未审核'),
      '1': t('已审核'),
      '2': t('未通过'),
      '3': t('终端审核'),
      '4': t('退回审核')
    };
    const subtitleOptions = [{
      label: t('全部'),
      value: ''
    }, {
      label: 'DVB',
      value: 'DVB'
    }, {
      label: 'Teletext',
      value: 'Teletext'
    }, {
      label: 'CC',
      value: 'CC'
    }, {
      label: 'TTML',
      value: 'TTML'
    }, {
      label: 'SRT',
      value: 'SRT'
    }];

    const findChannelStateByTag = tag => {
      // 根据激活的tag找到对应的state，激活的tag是'全部'的时候，因为没有对应state查询条件，所以不能用这个方法
      // tag和state的对照关系: 1:0   5:1    2、3、4: 2、3、4
      let state = 0;

      if (tag == 1) {
        return state = 0;
      } else if (tag == 5) {
        return state = 1;
      } else {
        return state = Number(tag);
      }
    };

    const calculateColor = state => {
      let color = '';

      switch (state) {
        case 0:
          color = "#606266";
          break;

        case 1:
          color = "rgb(62 213 150)";
          break;

        case 2:
          color = "red";
          break;

        case 3:
          color = "#0c60e1";
          break;

        case 4:
          color = "#0000004f";
          break;
      }

      return color;
    };

    const Tags = computed(() => {
      let common = objToArr(REVIEW_STATUS, 'type', 'name');
      return isShowAside.value ? common : [{
        type: 'close',
        name: '',
        noActive: true,
        icon: 'icon-ic_list'
      }, ...common];
    });
    onMounted(() => {
      loading.value = true;
      sessionStorage.setItem('currentCid', cpspId); //getSysDictList('code_protocol')
      //getEnList()
      //getLanguageList()
      // getCpspCategories(cpspId)

      getBrands(); // closeAside()

      getLiveChannelList(1, 10, {
        cpspId
      });
    }); // 处理点击事件

    const handleTagClick = tag => {
      // if(tag.type === 'close') return closeAside()
      activeTag.value = tag.type;
      const cid = isVnoAccount ? cpspId : sessionStorage.getItem('currentCid'); //运营商id

      let params = {
        cpspId: cid,
        ...searchParams
      };

      if (activeTag.value != 0) {
        params.state = findChannelStateByTag(activeTag.value);
      }

      params = { ...params,
        ...sortParams
      };
      getLiveChannelList(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit, params);
    };

    const handleSelectionChange = row => {
      selectedChannelIdList.value = [];
      selectedChannel.value = [];

      if (row.length > 0) {
        row.forEach(val => {
          selectedChannelIdList.value.push(val.id);
          selectedChannel.value.push(val);
        });
      } //console.log('选择的频道',selectedChannel.value)

    };

    const searchConfig = reactive({
      size: {
        sm: 24,
        md: 12,
        lg: 8,
        xl: 6,
        xs: {}
      },
      formList: [{
        label: '品牌',
        prop: 'cid',
        widgetType: 'Select',
        valueKey: 'cid',
        labelKey: 'prefixName',
        list: [],
        disabled: isVnoAccount,
        change: val => {
          // 品牌选择发生变化查询列表
          sessionStorage.setItem('currentCid', val);
          handleSearch({
            cid: val
          });
        }
      }, {
        label: '关键字筛选',
        prop: 'keyWord',
        widgetType: 'inputWithTooltip',
        placeholder: t('输入频道名称、节目识别号（原台标）、备注'),
        tooltip: true
      }, {
        label: '编码协议',
        prop: 'codeProtocol',
        widgetType: 'Select',
        list: sysDictList,
        valueKey: 'value',
        loading: false,
        visibleChange: async isVisible => {
          let nowItem = getItemByProp(searchConfig.formList, 'codeProtocol');

          if (isVisible && sysDictList.value.length <= 1) {
            nowItem.loading = true;
            await getSysDictList('code_protocol');
            nowItem.loading = false;
          }
        }
      }, {
        label: '分类属性',
        prop: 'categoryProperty',
        widgetType: 'Select',
        multiple: true,
        collapseTags: true,
        list: enList,
        valueKey: 'label',
        loading: false,
        visibleChange: async isVisible => {
          let nowItem = getItemByProp(searchConfig.formList, 'categoryProperty');

          if (isVisible && enList.value.length <= 1) {
            nowItem.loading = true;
            await getEnList();
            nowItem.loading = false;
          }
        }
      }, {
        label: '语言',
        prop: 'lang',
        widgetType: 'Select',
        multiple: true,
        collapseTags: true,
        list: languageList,
        valueKey: 'label',
        loading: false,
        visibleChange: async isVisible => {
          let nowItem = getItemByProp(searchConfig.formList, 'lang');

          if (isVisible && languageList.value.length <= 1) {
            nowItem.loading = true;
            await getLanguageList();
            nowItem.loading = false;
          }
        }
      }, {
        label: '创建时间',
        prop: 'createTime',
        widgetType: 'date',
        type: 'daterange',
        valueFormat: 'x'
      }, {
        label: '操作用户',
        prop: 'operatingUser',
        widgetType: 'Select',
        placeholder: '请选择操作用户',
        labelKey: 'name',
        valueKey: 'id',
        list: [{
          name: t('全部'),
          id: ''
        }],
        loading: false,
        visibleChange: async isVisible => {
          let nowItem = getItemByProp(searchConfig.formList, 'operatingUser');

          if (isVisible && nowItem.list.length <= 1) {
            nowItem.loading = true;
            await getUserByCid({
              cid: cpspId
            });
            nowItem.loading = false;
          }
        }
      }, {
        label: '激活状态',
        prop: 'physicalChannelState',
        widgetType: 'Select',
        list: activeList,
        valueKey: 'value'
      }, {
        label: '传输协议',
        prop: 'transferProtocol',
        widgetType: 'Select',
        list: transferProtocolObj,
        valueKey: 'value',
        loading: false,
        visibleChange: async isVisible => {
          let nowItem = getItemByProp(searchConfig.formList, 'transferProtocol');

          if (isVisible && transferProtocolObj.value.length <= 1) {
            nowItem.loading = true;
            await getSysDictList('transfer_protocol');
            nowItem.loading = false;
          }
        }
      }, {
        label: ' 显示编号',
        prop: 'showNo',
        widgetType: 'input'
      }, {
        label: '字幕类型',
        prop: 'subtitle',
        widgetType: 'Select',
        list: subtitleOptions,
        loading: false
      }],
      formData: {
        cid: Number(cpspId),
        operatingUser: '',
        codeProtocol: '',
        physicalChannelState: '',
        transferProtocol: '',
        subtitle: ''
      }
    }); // 监听表单勾选，选中则批量按钮可以点击，否则不能点

    watch(() => selectedChannelIdList.value, (newVal, oldVal) => {
      if (newVal.length > 0) {
        batchBtnDisabled.value = false;
      } else {
        batchBtnDisabled.value = true;
      }
    }); // 暂存频道信息文件，待接口提供后用于提交。

    const channelInfoImportFile = ref(null); // 复用原有的频道导入弹窗及上传流程。

    const openChannelImport = () => {
      dialogObj.dialogVisible = true;
      dialogObj.cid = sessionStorage.getItem('currentCid');
    }; // 频道信息导入接口占位；接口提供后替换为真实 API 请求。


    const importChannelInfoRequest = async _formData => {
      return {
        code: 'PENDING'
      };
    }; // 预设文件选择、请求、加载状态和成功刷新流程。


    const {
      openExcelImportDialog: selectChannelInfoImportFile
    } = useExcelImport({
      request: importChannelInfoRequest,
      setLoading: value => {
        loading.value = value;
      },
      onFileSelected: file => {
        channelInfoImportFile.value = file;
      },
      onSuccess: async () => {
        const cid = isVnoAccount ? cpspId : sessionStorage.getItem('currentCid');
        await getLiveChannelList(1, 10, {
          cpspId: cid
        });
      }
    });
    const tableConfig = reactive({
      data: [],
      isCardBlock: true,
      paginationConfig: {
        page: 1,
        limit: 10,
        total: 0
      },
      isShowHeader: false,
      headerButtonsList: [{
        label: '显示编号排序',
        permissionKey: 'LC_CR_RO',
        type: 'green',
        func: () => {
          //sortShowNo()
          messageBox(`${t('确定重新给显示编号排序吗')}?`).then(() => {
            sortShowNo();
          });
        }
      }, {
        label: '批量操作',
        key: 1,
        disabled: batchBtnDisabled.value,
        func: () => {},
        cellSlot: true,
        list: [{
          label: '审核',
          permissionKey: 'LC_CR_BT',
          func: () => {
            if (selectedChannel.value.length > 0) {
              const stateArr = selectedChannel.value.map(item => item.state);
              const isSameState = Array.from(new Set(stateArr)).length === 1;

              if (isSameState) {
                liveStore().addSelectedChannel(JSON.parse(JSON.stringify(selectedChannel.value)));
                operationObj.visible = true;
                operationObj.mode = 'state';
              } else {
                ElMessage({
                  type: 'error',
                  message: t('请勾选相同状态的频道')
                });
              }
            } else {
              return ElMessage({
                type: 'error',
                message: t('请选择至少一个频道')
              });
            }
          }
        }, {
          label: '回看',
          permissionKey: 'LC_CR_LB',
          func: () => {
            if (selectedChannelIdList.value.length === 0) return ElMessage({
              type: 'error',
              message: t('请至少选择一个频道')
            });
            lookBackObj.selectedChannel = selectedChannelIdList.value;
            lookBackObj.visible = true;
          }
        }, {
          label: '时移',
          permissionKey: 'LC_CR_TS',
          func: () => {
            if (selectedChannelIdList.value.length === 0) return ElMessage({
              type: 'error',
              message: t('请至少选择一个频道')
            }); // 节目存在非dash传输协议，不允许设置时移

            const channelOnlyHasDash = selectedChannel.value.filter(item => item.transferProtocol === null || item.transferProtocol == 1);
            if (channelOnlyHasDash.length !== selectedChannel.value.length) return ElMessage({
              type: 'error',
              message: t('所选频道存在非dash传输协议，不允许设置时移')
            });
            timeShiftObj.selectedChannel = selectedChannelIdList.value;
            timeShiftObj.visible = true;
          }
        }, {
          label: '删除',
          permissionKey: 'LC_CR_DL',
          func: () => {
            let promiseArr = [];
            if (selectedChannelIdList.value.length === 0) return ElMessage({
              type: 'error',
              message: t('请至少选择一个频道')
            });
            if (selectedChannel.value.filter(item => item.releaseState === 1).length > 0) return ElMessage({
              type: 'error',
              message: t('不能删除已上线的频道')
            });
            messageBox(`${t('确定删除这些频道吗')}?`).then(async () => {
              loading.value = true;

              try {
                let ids = selectedChannelIdList.value.join(',');
                let cid = isVnoAccount ? cpspId : sessionStorage.getItem('currentCid'); //运营商id

                const {
                  code
                } = await batchDeleteChannelsApi(ids, cid);

                if (code == 0) {
                  let params = {
                    cpspId: cid,
                    ...searchParams,
                    ...sortParams
                  };

                  if (activeTag.value != 0) {
                    params.state = findChannelStateByTag(activeTag.value);
                  }

                  getLiveChannelList(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit, params);
                }
              } catch (error) {
                console.error('批量删除频道失败', error);
              } finally {
                loading.value = false;
              }
            });
          }
        }, {
          label: '付费',
          func: () => {
            if (selectedChannelIdList.value.length === 0) return ElMessage({
              type: 'error',
              message: t('请至少选择一个频道')
            });
            paidSettingObj.visible = true;
            paidSettingObj.ids = selectedChannelIdList.value;
          }
        }, {
          label: '硬编码',
          func: () => {
            if (selectedChannelIdList.value.length === 0) return ElMessage({
              type: 'error',
              message: t('请至少选择一个频道')
            });
            EndcodingObj.visible = true;
            EndcodingObj.ids = selectedChannelIdList.value;
          }
        }]
      }, {
        label: '导出',
        permissionKey: 'LC_CR_OP',
        func: () => {
          let ids = selectedChannelIdList.value.toString();

          if (searchParams.categoryIds && searchParams.categoryIds.length !== 0) {
            // 按品牌导出，excel可分工作簿
            exportChannelList(searchParams.categoryIds.toString(), '');
          } else {
            // 正常按分类导出
            exportChannelList('', ids);
          }
        }
      }, {
        // 批量导入下拉：包含频道导入和频道信息文件导入入口。
        label: '批量导入',
        key: 2,
        func: () => {},
        cellSlot: true,
        list: [{
          label: '频道',
          permissionKey: 'LC_CR_IP',
          func: openChannelImport
        }, {
          label: '频道信息',
          permissionKey: 'LC_CR_IP',
          func: selectChannelInfoImportFile
        }]
      }, {
        label: '新增',
        type: 'yellow',
        permissionKey: 'LC_CR_AD',
        func: () => {
          addOrEditChannelObj.value = {
            mode: 'add',
            id: undefined,
            visible: true
          };
        }
      }, {
        label: '',
        key: 0,
        func: () => {},
        cellSlot: true
      }]
    });
    const columnConfig = reactive({
      columnList: [{
        label: '',
        prop: '',
        type: 'selection'
      }, {
        label: '序号',
        prop: 'no',
        align: 'left',
        width: 100
      }, {
        label: '频道名称',
        prop: 'name',
        align: 'left',
        width: 250,
        sortable: 'custom',
        'sort-orders': ['ascending', 'descending']
      }, {
        label: '节目识别号',
        prop: 'callSign',
        align: 'left',
        width: 200,
        sortable: 'custom',
        'sort-orders': ['ascending', 'descending']
      }, {
        label: ' 显示编号',
        prop: 'showNo',
        align: 'left',
        width: 108,
        sortable: 'custom',
        'sort-orders': ['ascending', 'descending']
      }, {
        label: '编码标准',
        prop: 'programType',
        align: 'left',
        width: 110,
        formatter: value => findLabel(ProgramTypeObject, value)
      }, {
        label: '字幕类型',
        prop: 'subtitle',
        align: 'left',
        width: 110,
        sortable: 'custom',
        'sort-orders': ['ascending', 'descending'],
        formatter: value => {
          if (value && value.length > 0) return Array.from(new Set(value.split(',').map(item => item.split('+')[0]))).join(',');
          return '--';
        }
      }, {
        label: '付费节目',
        prop: 'isPremium',
        align: 'left',
        width: 110,
        sortable: 'custom',
        'sort-orders': ['ascending', 'descending'],
        formatter: val => {
          return val == 0 ? t('否') : val == 1 ? 'VIP1' : 'VIP2';
        }
      }, {
        label: '审核状态',
        prop: 'state',
        align: 'left',
        formatter: value => ReviewStatus[value],
        cellSlot: true,
        slotName: 'stateColumn',
        width: 108
      }, {
        label: '操作用户',
        prop: 'operatorName',
        align: 'left',
        width: 120,
        formatter: value => {
          return value === null ? '/' : value;
        }
      }, {
        label: '创建时间',
        prop: 'createTime',
        align: 'left',
        width: 220,
        sortable: 'custom',
        'sort-orders': ['ascending', 'descending'],
        formatter: value => getCurrentTime(value)
      }, {
        label: '更新时间',
        prop: 'updateTime',
        align: 'left',
        width: 220,
        sortable: 'custom',
        'sort-orders': ['ascending', 'descending'],
        formatter: value => getCurrentTime(value)
      }, {
        label: '分类属性',
        prop: 'categoryProperty',
        width: 180,
        sortable: 'custom',
        'sort-orders': ['ascending', 'descending']
      }, {
        label: '关联信息',
        prop: 'info',
        width: 130,
        cellSlot: true,
        slotName: 'infoColumn'
      }, {
        label: '备注',
        prop: 'remark',
        align: 'left',
        width: 150
      }, {
        label: '操作',
        prop: '',
        align: 'left',
        widgetType: 'buttons',
        width: 250,
        fixed: 'right',
        buttonsList: [{
          label: '编辑',
          permissionKey: 'LC_CR_ED',
          controller: data => {
            if (data.releaseState !== 1) {
              return true;
            }
          },
          func: data => {
            console.log('edit', data); //router.push({path: `/live/channel-management/add-channel/${'edit'}`, query:{id:data.id}})  

            addOrEditChannelObj.value = {
              id: data.id,
              visible: true,
              mode: 'edit'
            };
          }
        }, {
          label: '审核',
          permissionKey: 'LC_CR_RV',
          func: data => {
            checkChannelObj.visible = true;
            checkChannelObj.detailInfo.id = data.id;
            checkChannelObj.detailInfo.state = data.state;
            checkChannelObj.detailInfo.checkFailedReason = data.checkFailedReason;
          }
        }, {
          label: '删除',
          permissionKey: 'LC_CR_SDL',
          controller: data => {
            if (data.releaseState !== 1) {
              return true;
            }
          },
          func: data => {
            let key = data.id;
            messageBox(`${t('确定删除频道')} ${data.name}?`).then(async () => {
              loading.value = true;

              try {
                const {
                  data: resData,
                  code
                } = await deleteChannelsApi(key);

                if (code == '0') {
                  const cid = isVnoAccount ? cpspId : sessionStorage.getItem('currentCid'); //运营商id

                  let params = {
                    cpspId: cid,
                    ...searchParams,
                    ...sortParams
                  };

                  if (activeTag.value != 0) {
                    params.state = findChannelStateByTag(activeTag.value);
                  }

                  getLiveChannelList(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit, params);
                }
              } catch (error) {
                console.error('删除频道失败', error);
              } finally {
                loading.value = false;
              }
            });
          }
        }, // 测试服更新的时候隐藏
        {
          label: '物理频道',
          permissionKey: 'LC_CR_PC',
          func: data => {
            physicalChannelObj.value.visible = true;
            physicalChannelObj.value.id = data.id;
            physicalChannelObj.value.state = data.state;
          }
        }]
      }]
    });

    const filterColumnItemChange = () => {
      nextTick(() => {
        tableRef.value && tableRef.value.commonTableRef.doLayout();
      });
    }; // 分页size变化的回调


    const sizeChange = size => {
      loading.value = true;
      tableConfig.paginationConfig.limit = size;
      let params = {};
      const cid = isVnoAccount ? cpspId : sessionStorage.getItem('currentCid'); //运营商id

      if (activeTag.value == 0) {
        params = {
          cpspId: cid,
          ...sortParams
        };
      } else {
        let state = findChannelStateByTag(activeTag.value);
        params = {
          cpspId: cid,
          state,
          ...sortParams
        };
      }

      params = { ...params,
        ...searchParams
      };
      getLiveChannelList(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit, params);
    }; // 页码变化的回调


    const currentChange = page => {
      loading.value = true;
      tableConfig.paginationConfig.page = page;
      let params = {};
      const cid = isVnoAccount ? cpspId : sessionStorage.getItem('currentCid'); //运营商id

      if (activeTag.value == 0) {
        params = {
          cpspId: cid,
          ...sortParams
        };
      } else {
        let state = findChannelStateByTag(activeTag.value);
        params = {
          cpspId: cid,
          state,
          ...sortParams
        };
      }

      params = { ...params,
        ...searchParams
      };
      getLiveChannelList(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit, params);
    };

    const tableWidth = ref('0px'); // 关闭侧边栏
    // const closeAside = () => {
    //   tagRef.value.activeType = activeTag.value.toString()
    //   isShowAside.value = !isShowAside.value
    //   if(isShowAside.value){
    //     // 侧边栏展开则把右边table容器的宽度设置成未展开时的宽度
    //     tableContainer.value.style.width = tableWidth.value + 'px'
    //   } else {
    //     //关闭侧边栏，记录展开时的宽度
    //      tableWidth.value = tableContainer.value.offsetWidth 
    //   }
    // }
    // 导入

    const dialogObj = reactive({
      dialogVisible: false,
      title: '导入频道',
      width: '25%',
      successBtnText: '确定导入',
      closeBtnText: '取消',
      isFooter: true,
      uploadMode: 1,
      cid: cpspId //  当前品牌|选中的品牌的cpspId

    });

    const onCloseDialog = isUploadFail => {
      dialogObj.dialogVisible = false;

      if (isUploadFail) {
        ElMessage({
          type: 'error',
          message: 'upload fail'
        });
      }
    };

    const onDialogSubmit = isUploadSuccess => {
      dialogObj.dialogVisible = false;
      const cid = isVnoAccount ? cpspId : sessionStorage.getItem('currentCid'); //运营商id

      if (isUploadSuccess) {
        getLiveChannelList(1, 10, {
          cpspId: cid
        });
      }
    }; // 获取直播频道列表


    const getLiveChannelList = async (pageNo = 1, pageSize = 5, params = {}, orderBy = '', orderType = '') => {
      loading.value = true;

      try {
        const {
          code,
          data
        } = await getLiveChannelListApi(pageNo, pageSize, params);

        if (code === '0') {
          tableConfig.data = data.records.map((item, index) => {
            return { ...item,
              no: (pageNo - 1) * pageSize + index + 1 // 序号

            };
          });
          tableConfig.paginationConfig.page = data.current;
          tableConfig.paginationConfig.total = data.total;
          tableConfig.paginationConfig.limit = data.size;
        }
      } catch (error) {
        console.error('获取直播频道列表失败', error);
      } finally {
        loading.value = false;
      }
    }; // 获取语言列表


    const getLanguageList = async () => {
      try {
        const {
          code,
          data
        } = await getLanguageListApi();

        if (code === '0') {
          languageList.value = [...languageList.value, ...data];
        }
      } catch (error) {
        console.error('获取语言列表失败', error);
      }
    }; // 导出列表


    const exportChannelList = async (categoryId, ids) => {
      loading.value = true;

      try {
        const cid = isVnoAccount ? cpspId : sessionStorage.getItem('currentCid'); //运营商id

        const params = {
          beginTime: searchParams.beginTime,
          categoryProperty: searchParams.categoryProperty,
          endTime: searchParams.endTime,
          keyword: searchParams.keyword,
          language: searchParams.language,
          operator: searchParams.operator,
          programType: searchParams.programType
        };
        const res = await exportChannelListApi(categoryId, ids, cid, params);
        const blob = new Blob([res], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const objectUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = `CHANNEL_${dayjs(new Date()).format('YYYY-MM-DD')}`;
        a.click();
        a.remove();
        window.URL.revokeObjectURL(objectUrl);
      } catch (err) {
        console.error('导出频道列表失败', err);
      } finally {
        loading.value = false;
      }
    }; // 获取编码协议列表


    const getSysDictList = async type => {
      try {
        const {
          code,
          data
        } = await getSysDictListApi(type);

        if (code === '0') {
          if (type === 'code_protocol') {
            sysDictList.value = [...sysDictList.value, ...data];
          } else {
            transferProtocolObj.value = [{
              value: '',
              label: t('全部')
            }, ...data].filter(item => item.value !== 4);
          }
        }
      } catch (error) {
        console.error('获取协议列表失败', error);
      }
    }; // 获取子品牌下拉列表


    const getsubBrandList = async () => {
      try {
        const {
          code,
          data
        } = await getsubBrandListApi(cpspId); //TODO:接口没好不能用
        // 这里可以根据需要处理 data
      } catch (error) {
        console.error('获取子品牌列表失败', error);
      }
    }; // 获取分类属性列表


    const getEnList = async () => {
      try {
        const {
          code,
          data
        } = await getEnListApi(cpspId);

        if (code === '0') {
          enList.value = [...enList.value, ...data];
        }
      } catch (error) {
        console.error('获取分类属性列表失败', error);
      }
    }; // 获取子品牌直播分类列表


    const treeData = ref([]);
    const treeRef = ref();

    const getCpspCategories = async (id, keyword = '', codeProtocol = '') => {
      try {
        let params = {
          cid: id
        };

        if (keyword !== '') {
          params.keyword = keyword;
        }

        if (codeProtocol !== '') {
          params.codeProtocol = Number(codeProtocol);
        }

        const {
          code,
          data
        } = await getCpspCategoriesApi(params);

        if (code === '0') {
          data !== null && data.forEach(item => item.value = 'key' + item.cpspId); // 不执行这段，重置的时候会有bug

          treeData.value = data;
          console.log('treedata', treeData);
        }
      } catch (error) {
        console.error('获取分类列表失败', error);
      }
    }; // 获取品牌选项数据


    const getBrands = async () => {
      try {
        const brands = await useBrandsByUser();
        let searchItem = getItemByProp(searchConfig.formList, 'cid');
        if (searchItem) searchItem.list = brands;
        const cid = cpspId;

        if (!cid) {
          sessionStorage.setItem('currentCid', brands[0].cid);
        } // getUserByCid({ cid: cpspId || brands[0].cid })

      } catch (error) {
        console.error('获取品牌列表失败', error);
      }
    }; // 获取操作用户


    const getUserByCid = async params => {
      try {
        const res = await getUserByCidApi(params);
        console.log('getUserByCidApi', res);

        if (res.code == '0') {
          let item = getItemByProp(searchConfig.formList, 'operatingUser');
          item.list = [...item.list, ...res.data];
          operatorList.value = [...res.data];
        }
      } catch (error) {
        console.error('获取操作用户失败', error);
      }
    }; // 搜索按钮的回调


    let searchParams = reactive({
      categoryIds: [],
      cpspId
    });

    const handleSearch = formData => {
      console.log('search', formData);
      sessionStorage.setItem('currentCid', searchConfig.formData.cid.toString()); // 只有点击查询才能变更currentCid

      if (formData.keyWord && formData.keyWord.length > 255) return ElMessage({
        type: 'error',
        message: t('关键字的长度应在1到255字符之间')
      }); // 整理数据

      for (let key in formData) {
        switch (key) {
          case 'categoryProperty':
            if (formData[key].length === 0) {
              searchParams.categoryProperty = '';
            } else {
              searchParams.categoryProperty = formData[key].includes(t('全部')) ? '' : formData[key].toString();
            }

            break;

          case 'codeProtocol':
            searchParams.programType = formData[key];
            break;

          case 'createTime':
            searchParams.beginTime = transferTime(formData[key][0]);
            searchParams.endTime = transferTime(formData[key][1]);
            break;

          case 'keyWord':
            searchParams.keyword = formData[key];
            break;

          case 'lang':
            if (formData[key].length === 0) {
              searchParams.language = '';
            } else {
              searchParams.language = formData[key].includes(t('全部')) ? '' : formData[key].toString();
            }

            break;

          case 'operatingUser':
            searchParams.operator = formData[key];
            break;

          case 'physicalChannelState':
            searchParams.physicalChannelState = formData[key];
            break;

          case 'transferProtocol':
            searchParams.transferProtocol = formData[key];
            break;

          case 'showNo':
            searchParams.showNo = formData[key];
            break;

          case 'subtitle':
            searchParams.subtitle = formData[key];
            break;
        }
      }

      console.log('searchParams', searchParams); // 整理searchParams

      for (let key in searchParams) {
        if (searchParams[key] === '' || searchParams[key].length === 0) {
          delete searchParams[key];
        }
      } // const selectNoting = Object.keys(searchParams).length===2 && searchParams.categoryIds.length === 0
      // if(selectNoting) return handleReset() // 在什么条件都没有的情况下，点击查询等同于重置 后续测试没问题可删
      // 具备查询条件 区分当前tag是否为全部


      let params = {};
      const cid = isVnoAccount ? cpspId : sessionStorage.getItem('currentCid'); //运营商id

      if (activeTag.value == 0) {
        params = { ...sortParams
        };
      } else {
        let state = findChannelStateByTag(activeTag.value);
        params = {
          state,
          ...sortParams
        };
      }

      searchParams.cpspId = cid;
      params = { ...params,
        ...searchParams
      };
      getLiveChannelList(1, tableConfig.paginationConfig.limit, params);

      if (!isVnoAccount) {
        // 不是运营商的账号需要重新获取分类列表
        const cid = sessionStorage.getItem('currentCid'); //运营商id
        //getCpspCategories(cid, '', searchParams.programType)
      }
    }; // 重置按钮的回调


    const handleReset = () => {
      tableConfig.data = [];
      searchParams = reactive({
        categoryIds: [],
        cpspId: isVnoAccount ? cpspId : 0
      });
      searchConfig.formData = {
        cid: isVnoAccount ? cpspId : 0,
        operatingUser: '',
        codeProtocol: '',
        physicalChannelState: '',
        transferProtocol: '',
        subtitle: ''
      };
      sortParams.orderBy = undefined;
      sortParams.orderType = undefined;
      tableRef.value.commonTableRef.clearSort(); //清空排序条件

      enList.value = [];
      languageList.value = [];

      if (!isVnoAccount) {
        sessionStorage.setItem('currentCid', '0'); // 将sessionStorage重置为0，下次刷新时保证品牌默认选中的为0
      } // treeRef.value.setCheckedKeys([], false) //重置树形组件未未选中状态


      tagRef.value.onTagClick({
        name: '全部',
        type: '0'
      }); //重置tag激活全部选项

      let id = isVnoAccount ? cpspId : 0; //getEnList()
      //getLanguageList()
      // getCpspCategories(id)
    };

    const defaultProps = reactive({
      children: 'children',
      label: 'label'
    });

    const handleCheck = (data, {
      checkedNodes,
      checkedKeys,
      halfCheckedNodes,
      halfCheckedKeys
    }) => {
      //console.log('data',data)
      console.log('node', checkedNodes);
      selectedNodes.value = checkedNodes; // data:object 勾选的节点数据 
      // checkedNodes:[{}] 勾选节点的数据，单独勾选子节点的时候元素内不会有children属性，出现children属性即有父节点被选中  
      // checkedKeys:[number] 已勾选的节点node-key
      // halfCheckedNodes:array 半勾选的节点数据，一般是父节点的数据
      // halfCheckedKeys:array  半勾选的节点node-key，一般是父节点的key

      const hasParentNode = halfCheckedKeys.length !== 0;
      const cid = isVnoAccount ? cpspId : sessionStorage.getItem('currentCid'); //运营商id

      searchParams.cpspId = cid;
      searchParams.categoryIds = []; // 请求参数

      let params = { ...searchParams
      };
      if (activeTag.value !== 0) params.state = findChannelStateByTag(activeTag.value);
      if (checkedNodes.length === 0) return getLiveChannelList(1, 10, params); //无选中节点
      // 过滤出子节点，也就是不含childred字段的节点数据

      let filterNodes = checkedNodes.filter(node => node.children === null || node.children.length === 0);

      if (hasParentNode) {
        // 点击子节点的情况： 1.仅点击子节点，不存在父节点选中 2.父节点选中，选中另外的子节点
        let parentArr = [];
        checkedNodes.forEach(item => {
          if (item.children && item.children.length > 0) {
            parentArr.push(item);
          }
        });

        if (parentArr.length > 0) {
          // 情况2
          filterNodes.forEach(item => searchParams.categoryIds.push(item.value));
        } else {
          // 情况1
          checkedNodes.forEach(item => {
            searchParams.categoryIds.push(item.value);
          });
        }
      } else {
        // 仅点击父节点的情况
        filterNodes.forEach(item => searchParams.categoryIds.push(item.value));
      } // 调接口查询列表


      getLiveChannelList(1, 10, params);
    }; // 监听


    const sortShowNo = async () => {
      console.log('tag', activeTag.value);
      let params = {};
      const cid = isVnoAccount ? cpspId : sessionStorage.getItem('currentCid'); //运营商id

      searchParams.cpspId = cid;

      if (activeTag.value == 0) {
        params = { ...sortParams
        };
      } else {
        let state = findChannelStateByTag(activeTag.value);
        params = {
          state,
          ...sortParams
        };
      }

      loading.value = true;
      params = { ...params,
        ...searchParams
      };

      try {
        await sortShowNoApi(cid);
        getLiveChannelList(1, 10, params);
      } catch (error) {
        console.error('显示编号排序失败', error);
      } finally {
        loading.value = false;
      }
    }; // 批量操作


    const operationObj = reactive({
      visible: false,
      mode: 'state'
    });

    const onUpdateList = (refreshList = true) => {
      if (refreshList) {
        handleTagClick({
          type: activeTag.value.toString()
        }); // 请求对应tag的列表数据
      } else {
        let params = { ...sortParams,
          ...searchParams
        };
        getLiveChannelList(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit, params);
      }

      nextTick(() => {
        tagRef.value.activeType = activeTag.value.toString();
      });
    };

    const onCancel = () => {
      selectedChannel.value = [];
      nextTick(() => {
        tagRef.value.activeType = activeTag.value.toString(); //激活对应的tag标签

        handleTagClick({
          type: activeTag.value.toString()
        }); // 请求对应tag的列表数据
      });
    }; // 审核频道


    const checkChannelObj = reactive({
      visible: false,
      mode: 'check',
      detailInfo: {
        title: '频道审核',
        state: 0,
        id: 0,
        checkFailedReason: ''
      }
    }); //由审核频道改为编辑频道模式

    const onJumpToEdit = channelId => {
      console.log('jump', channelId);
      addOrEditChannelObj.value = {
        visible: true,
        mode: 'edit',
        id: channelId
      };
    }; // 由物理频道模式跳转审核频道模式


    const onJumpToCheck = jumpData => {
      console.log('jump', jumpData);
      checkChannelObj.visible = true;
      checkChannelObj.detailInfo.id = jumpData.id;
      checkChannelObj.detailInfo.state = jumpData.state;
      checkChannelObj.detailInfo.checkFailedReason = jumpData.checkFailedReason;
    }; // 编辑频道|新增频道


    const addOrEditChannelObj = ref({
      visible: false,
      mode: 'edit',
      id: undefined
    }); // watch(() => tableConfig.data, (val) => {
    //   nextTick(() => {
    //     const columntree = document.querySelector('#columntree') as HTMLElement
    //     columntree.style.maxHeight = tableWarpRef.value.offsetHeight + 'px'
    //   })
    // })

    const handleSortChange = sortType => {
      sortParams.orderBy = sortType.prop ? sortType.prop : undefined;

      if (sortType.order) {
        sortParams.orderType = sortType.order === 'ascending' ? 'ASC' : 'DESC';
      } else {
        sortParams.orderType = undefined;
      }

      let params = {};
      const cid = isVnoAccount ? cpspId : sessionStorage.getItem('currentCid'); //运营商id

      if (activeTag.value == 0) {
        params = {
          cpspId: cid,
          ...sortParams
        };
      } else {
        let state = findChannelStateByTag(activeTag.value);
        params = {
          cpspId: cid,
          state,
          ...sortParams
        };
      }

      params = { ...params,
        ...searchParams
      };
      getLiveChannelList(tableConfig.paginationConfig.page, tableConfig.paginationConfig.limit, params);
    }; // 物理频道模块


    const physicalChannelObj = ref({
      visible: false,
      mode: 'edit',
      id: undefined,
      state: undefined
    }); // 获取关联分类Tree

    const getCategoryTree = async id => {
      let targetTree = [];

      try {
        const {
          code,
          data
        } = await getChannelDetailApi(id);

        if (code == 0) {
          if (data.categoryPrograms && data.categoryPrograms.length > 0) {
            data.categoryPrograms.forEach(val => {
              // 根据详情返回的categoryId往treeData中找到目标的节点，结构为:[{label:a,children:{}},{label:a,children:{}}]
              let treeNode = XEUtils.searchTree(treeData.value, item => item.value == val.categoryId)[0];
              targetTree.push(treeNode);
            }); //最后合并相同的节点

            infoTreeData.value = treeIterator(targetTree);
          }
        } else {
          infoTreeData.value = [];
        }
      } catch (error) {
        console.error('获取频道详情失败', error);
        infoTreeData.value = [];
      }
    };

    const infoTreeData = ref([]); //表格关联信息展示

    const onShowInfo = row => {
      infoTreeData.value = [];
      getCategoryTree(row.id);
      infoDialog.visible = true;
    }; // 监听审核频道visible的变化，隐藏显示频道模块，tag标签激活为上次点击的


    watch(() => checkChannelObj.visible, newVal => {
      if (!newVal) return nextTick(() => {
        tagRef.value.activeType = activeTag.value.toString();
      });
    }); // 审核页面的显示与隐藏

    const mainPageVisible = computed(() => {
      if (!operationObj.visible && !checkChannelObj.visible && !addOrEditChannelObj.value.visible && !physicalChannelObj.value.visible) {
        return true;
      } else {
        return false;
      }
    }); // 监听主页的显示，设置tree组件节点选中状态

    watch(() => mainPageVisible.value, newVal => {
      if (newVal) {
        //将左侧el-tree勾选状态还原
        nextTick(() => {
          selectedNodes.value.forEach(item => {
            treeRef.value.setChecked(item.value, true, false);
          });
        });
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_search_form = _resolveComponent("search-form");

      const _component_TableColumnOptionBtn = _resolveComponent("TableColumnOptionBtn");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _directive_crosswiseScroll = _resolveDirective("crosswiseScroll");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_search_form, {
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        size: searchConfig.size,
        onSearch: handleSearch,
        onReset: handleReset,
        gutter: 30
      }, null, 8, ["form-list", "form-data", "size"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: "table__container",
        ref_key: "tableContainer",
        ref: tableContainer
      }, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(TagType, {
        modelValue: _unref(Tags),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(Tags) ? Tags.value = $event : null),
        onOnTagClick: handleTagClick,
        ref_key: "tagRef",
        ref: tagRef
      }, null, 8, ["modelValue"]), _createVNode(Buttons, {
        class: "header__btns",
        "buttons-list": tableConfig.headerButtonsList
      }, {
        cellSlot: _withCtx(scope => [scope.key == 0 ? (_openBlock(), _createBlock(_component_TableColumnOptionBtn, {
          key: 0,
          "column-list": columnConfig.columnList,
          onFilterColumnItemChange: filterColumnItemChange
        }, null, 8, ["column-list"])) : _createCommentVNode("", true), scope.key == 1 ? (_openBlock(), _createBlock(BatchButton, {
          key: 1,
          title: scope.label,
          "buttons-list": scope.list,
          disabled: batchBtnDisabled.value
        }, null, 8, ["title", "buttons-list", "disabled"])) : _createCommentVNode("", true), scope.key == 2 ? (_openBlock(), _createBlock(BatchButton, {
          key: 2,
          title: scope.label,
          "buttons-list": scope.list
        }, null, 8, ["title", "buttons-list"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["buttons-list"])])), [[_directive_crosswiseScroll]]), _createElementVNode("div", {
        class: "table-list",
        ref_key: "tableWarpRef",
        ref: tableWarpRef
      }, [_createVNode(_component_common_table, {
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        ref_key: "tableRef",
        ref: tableRef,
        onSizeChange: sizeChange,
        onCurrentChange: currentChange,
        onSelectionChange: handleSelectionChange,
        onSortChange: handleSortChange
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, {
          stateColumn: _withCtx(scope => [_createElementVNode("span", {
            style: _normalizeStyle({
              'color': calculateColor(scope.row.state)
            })
          }, _toDisplayString(ReviewStatus[scope.row.state]), 5)]),
          infoColumn: _withCtx(scope => [_createElementVNode("span", {
            class: "link",
            onClick: $event => onShowInfo(scope.row)
          }, _toDisplayString(_ctx.$t('信息')), 9, _hoisted_4)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config", "pagination-config"])], 512)], 512)])])), [[_directive_loading, loading.value], [_vShow, _unref(mainPageVisible)]]), dialogObj.dialogVisible ? (_openBlock(), _createBlock(UploadFile, {
        key: 0,
        "dialog-object": dialogObj,
        onDialogClose: onCloseDialog,
        onDialogSuccess: onDialogSubmit
      }, null, 8, ["dialog-object"])) : _createCommentVNode("", true), _createVNode(BatchOperation, {
        modelValue: operationObj.visible,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => operationObj.visible = $event),
        mode: operationObj.mode,
        onUpdateList: onUpdateList,
        onCancel: onCancel
      }, null, 8, ["modelValue", "mode"]), _createVNode(CheckChannel, {
        modelValue: checkChannelObj.visible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => checkChannelObj.visible = $event),
        mode: checkChannelObj.mode,
        "detail-info": checkChannelObj.detailInfo,
        onUpdateList: onUpdateList,
        onJumpToEdit: onJumpToEdit
      }, null, 8, ["modelValue", "mode", "detail-info"]), _createVNode(AddChannel, {
        modelValue: addOrEditChannelObj.value.visible,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => addOrEditChannelObj.value.visible = $event),
        mode: addOrEditChannelObj.value.mode,
        id: addOrEditChannelObj.value.id,
        onUpdateList: onUpdateList,
        onCancel: onCancel
      }, null, 8, ["modelValue", "mode", "id"]), _createVNode(PhysicalChannel, {
        modelValue: physicalChannelObj.value.visible,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => physicalChannelObj.value.visible = $event),
        channelData: physicalChannelObj.value,
        onUpdateList: onUpdateList,
        onCancel: onCancel,
        onJumpToCheck: onJumpToCheck
      }, null, 8, ["modelValue", "channelData"]), _createVNode(InfoDialog, {
        modelValue: infoDialog.visible,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => infoDialog.visible = $event),
        "info-tree-data": infoTreeData.value
      }, null, 8, ["modelValue", "info-tree-data"]), _createVNode(LookBack, {
        modelValue: lookBackObj.visible,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => lookBackObj.visible = $event),
        selectedChannel: lookBackObj.selectedChannel,
        onUpdateList: onUpdateList
      }, null, 8, ["modelValue", "selectedChannel"]), _createVNode(TimeShift, {
        modelValue: timeShiftObj.visible,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => timeShiftObj.visible = $event),
        selectedChannel: timeShiftObj.selectedChannel,
        onUpdateList: onUpdateList
      }, null, 8, ["modelValue", "selectedChannel"]), _createVNode(PaidSetting, {
        modelValue: paidSettingObj.visible,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => paidSettingObj.visible = $event),
        data: paidSettingObj.ids,
        onUpdateList: onUpdateList
      }, null, 8, ["modelValue", "data"]), _createVNode(Encoding, {
        modelValue: EndcodingObj.visible,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => EndcodingObj.visible = $event),
        data: EndcodingObj.ids,
        onUpdateList: onUpdateList
      }, null, 8, ["modelValue", "data"])], 64);
    };
  }

});